module.exports = __webpack_public_path__ + "assets/img/travel-day50.b86fa3c0.png";